import styled from "styled-components"
import { purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
  height: 100%;
  
  &:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    transform: translateY(-4px);
  }
`;

const ImageContainer = styled.div<{ imageUrl: string }>`
  width: 100%;
  height: 12rem;
  background-image: url(${props => props.imageUrl});
  background-size: cover;
  background-position: center;
  flex-shrink: 0;

  @media (min-width: 768px) {
    height: 16rem;
  }
`;

const CardContent = styled.div`
  padding: 1.5rem;
display: flex;
flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  
  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${slateColors[900]};
  margin: 0;
  line-height: 1.3;
  
  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

const CardBody = styled.p`
  font-size: 0.9375rem;
  color: ${slateColors[600]};
  margin: 0;
  line-height: 1.6;
  flex: 1;
  
  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const LearnMoreLink = styled.span`
  color: ${purpleColors[600]};
  font-weight: 600;
  font-size: 0.9375rem;
  margin-top: 0.25rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  
  &::after {
    content: '→';
    transition: transform 0.2s;
  }
  
  ${Card}:hover &::after {
    transform: translateX(4px);
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
`;

interface PromoCardProps {
    imageUrl: string;
    title: string;
    body: string;
  showLearnMore?: boolean;
  linkTo?: string;
}

const PromoCard = ({ imageUrl, title, body, showLearnMore, linkTo }: PromoCardProps) => {
  const { t } = useTranslation();
  
  const cardContent = (
    <Card>
      <ImageContainer imageUrl={imageUrl} />
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardBody>{body}</CardBody>
                {showLearnMore && (
          <LearnMoreLink>{t('promoCard.learnMore')}</LearnMoreLink>
                )}
      </CardContent>
    </Card>
  );

  if (linkTo) {
    return <StyledLink to={linkTo}>{cardContent}</StyledLink>;
  }

  return cardContent;
  };
  
  export default PromoCard;
